import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

const CorrRowColTable = ({ rowData, index }) => {
  return (
    <div key={uuid()} className="c-table--row" data-test="corrRowColTableComponent">
      <div className="c-table-private-col">
        <div className="c-table--col">
          <div className="cell-content">
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.mass}
                data-class={`p${index}`}
              >{rowData.mass}
              </div>
            </div>
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.audience}
                data-class={`p${index}`}
              >{rowData.audience}
              </div>
            </div>
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.inertia}
                data-class={`p${index}`}
              >{rowData.inertia}
              </div>
            </div>
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.coo1}
                data-class={`p${index}`}
              >{rowData.coo1}
              </div>
            </div>
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.cor1}
                data-class={`p${index}`}
              >{rowData.cor1}
              </div>
            </div>
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.ctr1}
                data-class={`p${index}`}
              >{rowData.ctr1}
              </div>
            </div>
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.coo2}
                data-class={`p${index}`}
              >{rowData.coo2}
              </div>
            </div>
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.cor2}
                data-class={`p${index}`}
              >{rowData.cor2}
              </div>
            </div>
            <div className="cell-value">
              <div
                className='gen-cell-value-next-rows'
                title={rowData.ctr2}
                data-class={`p${index}`}
              >{rowData.ctr2}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CorrRowColTable.propTypes = {
  rowData: PropTypes.instanceOf(Object),
  index: PropTypes.number,
};

export default CorrRowColTable;
